<h2
  mat-dialog-title
  mat-dialog-draggable-title
  style="margin-bottom: 0px !important"
>
  <span style="color: #ff0202">{{'alert.notification' | translate}}</span>
</h2>
<mat-dialog-content>
  <mat-divider></mat-divider>
  <div class="row mt-2" style="padding: 5px 10px">
    <div class="col-2 pr-0" style="text-align: center;padding-left: 0px !important; padding-top: 15px;">
      <!--<em class="material-icons confirm-ico">
        info
      </em>-->
      <em class="fa fa-warning text-primary large"></em>
    </div>
    <div class="col-10 pl-0" style="font-size: medium; overflow-wrap: break-word">
      {{ "messages.contract_not_enough_storage" | translate }}
    </div>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="justify-content-center mt-2">
  <!--build icon, set default cancel-->
  <button mat-raised-button color="primary" class="ml-2" (click)="onNoClick()">
    <mat-icon class="mr-0" style="margin-right: 5px !important;">cancel</mat-icon>{{ "button.close" | translate }}
  </button>
</div>
